import React from "react";

const Header: React.FC = () => {
  return (
    <div className="bg-white px-2 lg:px-0 w-full hidden lg:flex items-center justify-center">
      <div className="flex lg:flex-row flex-col gap-4 lg:gap-0 items-center w-full justify-between max-w-5xl h-32 bg-white">
        <div>
          <img className="lg:w-full w-[100px] mt-5 lg:mt-0" src="/logo.svg" />
        </div>
        <div>
          <div className="flex gap-4 px-5 py-4 items-center justify-center bg-[#f6fcf1] border border-[#dae3d2] rounded-2xl">
            <img src="/icon-delivery.svg" />
            <div className="flex flex-col text-[#5BB947]">
              <h2 className="font-extrabold text-lg">FRETE GRÁTIS</h2>
              <h3 className="font-medium text-[14px]">PARA TODO BRASIL</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
